module.exports = __webpack_public_path__ + "img/jeu-2.9d9f459e.png";